import {Controller} from '@hotwired/stimulus'
import {Carousel} from 'utils/bootstrap'

export default class extends Controller {
  static values = {
    delay: {type: Number, default: 5000},
    useDelay: {type: Boolean, default: true},
  }

  connect() {
    const init = () => {
      this.element.classList.remove('d-none')
      Carousel.getOrCreateInstance(this.element).cycle()
    }

    if (this.useDelayValue)
      setTimeout(init, this.delayValue)
    else
      init()
  }

  disconnect() {
    Carousel.getInstance(this.element)?.dispose()
  }
}
